import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteDiscountRule = {
  name: "deleteDiscountRule" as const,
  input: z.object({ ruleId: zExt.objectId() }),
  output: z.null(),
};
